import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../../../contexts";
import { MANAGEMENT_MODULES } from "../../../utils/managementModules";
import "./ManagementModuleTitle.scss";

// Título de página que además funciona como selector para saltar a otro
// módulo de "Gestión" (Plan Anual, Matriz Legal, Accidentes, Evaluación de
// Riesgos, Permisos de Trabajo, Planes de Acción) sin volver al menú lateral.
export function ManagementModuleTitle({ labelClassName = "" }) {
  const { pathname } = useLocation();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const current = MANAGEMENT_MODULES.find((m) => pathname.startsWith(m.path));
  const currentLabel = current ? t(current.labelKey) : "";

  return (
    <div className="mm-title" ref={ref}>
      <button type="button" className="mm-title__toggle" onClick={() => setOpen((v) => !v)}>
        <span className={labelClassName}>{currentLabel}</span>
        <svg
          viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round" width="16" height="16"
          className={`mm-title__arrow${open ? " mm-title__arrow--open" : ""}`}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div className="mm-title__menu">
          {MANAGEMENT_MODULES.map((m) => (
            <Link
              key={m.path}
              to={m.path}
              className={`mm-title__item${pathname.startsWith(m.path) ? " mm-title__item--active" : ""}`}
              onClick={() => setOpen(false)}
            >
              {t(m.labelKey)}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
